import { defineStore } from 'pinia'
import website from '@/const/website.js'
import { getSession, setSession } from '../utils/store'

const isFirstPage = website.isFirstPage
const tagWel = website.fistPage
const tagObj = {
  label: '', // 标题名称
  value: '', // 标题的路径
  params: '', // 标题的路径参数
  query: '', // 标题的参数
  group: [] // 分组
}

// 处理首个标签
function setFistTag(list) {
  if (list.length === 1) {
    list[0].close = false
  } else {
    list.forEach(ele => {
      ele.close = !(ele.value === tagWel.value && !isFirstPage)
    })
  }
}

export const useTagStore = defineStore('tag', {
  state: () => ({
    tagList: getSession({
      name: 'tagList'
    }) || [],
    tag: getSession({
      name: 'tag'
    }) || tagObj,
    tagWel: tagWel
  }),
  actions: {
    // 添加tag
    addTag(obj) {
      this.tag = obj
      setSession({ name: 'tag', content: this.tag })
      if (this.tagList.some(x => x.label === obj.label && x.value === obj.value)) return
      this.tagList.push(obj)
      setFistTag(this.tagList)
      setSession({ name: 'tagList', content: this.tagList })
    },
    // 清除某个tag
    delTag(obj) {
      this.tagList = this.tagList.filter(x => x.label !== obj.label && x.value !== obj.value)
      setFistTag(this.tagList)
      setSession({ name: 'tagList', content: this.tagList })
    },
    // 清除所有tag
    delAllTags() {
      this.tagList = [this.tagWel]
      setSession({ name: 'tagList', content: this.tagList })
    },
    // 清除除了当前标签之外的其他标签
    delOtherTags() {
      this.tagList = this.tagList.filter(x => x.value === this.tag.value || (!isFirstPage && x.value === tagWel.value))
      setFistTag(this.tagList)
      setSession({ name: 'tagList', content: this.tagList })
    }
  }
})